export const DO_SELF_ASSESSMENT_REQUEST = 'DO_SELF_ASSESSMENT_REQUEST';
export const DO_SELF_ASSESSMENT_SUCCESS = 'DO_SELF_ASSESSMENT_SUCCESS';
export const DO_SELF_ASSESSMENT_FAILURE = 'DO_SELF_ASSESSMENT_FAILURE';

export const SELF_ASSESSMENT_SET_IS_LOADING = 'SELF_ASSESSMENT_SET_IS_LOADING';
